import { render, staticRenderFns } from "./main-navbar.vue?vue&type=template&id=609b244d&scoped=true"
import script from "./main-navbar.vue?vue&type=script&lang=js"
export * from "./main-navbar.vue?vue&type=script&lang=js"
import style0 from "./main-navbar.vue?vue&type=style&index=0&id=609b244d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b244d",
  null
  
)

export default component.exports